export const commonEnv = {
  infoDashboard: {
    title: 'Wissenszentrale für gemeinsamen Erfolg.',
  },
};
